/* eslint-disable */
export default ({ app }) => {
  /*
  ** Only run on client-side and only in production mode
  */
  // if (process.env.NODE_ENV !== 'production') return

  /*
  ** Include Analytics Script
  */
 var _paq = window._paq || [];
  /*
    ** Every time the route changes (fired on initialization too)
    */
  app.router.afterEach((to, from) => {
    // console.log('track route change');
    var currentUrl = location.origin;
    _paq.push(['setReferrerUrl', currentUrl]);
    // get page name
    let currentPageTitle = to.name;
    /*
    ** We tell Analytics to add a `pageview`
    */
   currentUrl += to.fullPath;
    _paq.push(['setCustomUrl', currentUrl]);
    _paq.push(['setDocumentTitle', currentPageTitle]);
    // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
    _paq.push(['deleteCustomVariables', 'page']); 
    _paq.push(['setGenerationTimeMs', 0]);
    _paq.push(['trackPageView']);

    // make Matomo aware of newly added content
    var content = document.getElementById('__nuxt');
    _paq.push(['MediaAnalytics::scanForMedia', content]);
    _paq.push(['FormAnalytics::scanForForms', content]);
    _paq.push(['trackContentImpressionsWithinNode', content]);
    _paq.push(['enableLinkTracking']);

    if (process.env.NODE_ENV !== 'production') {
      // just show and flush log
      console.log('tracking: ', _paq.map(item => item.toString()));
      _paq.splice(0);
    }
  })
}
